import { Button, Input, Flex, Divider } from 'antd';
import React, { useEffect, useState } from "react";
import common_axios from "./../commonAxios";
import "./AdminIngredient.css";

const AdminIngredient = () => {

    const [ingredients, setIngredients] = useState([]);
    const [postName, setName] = useState("");

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        common_axios.get(`${process.env.REACT_APP_API_URL}/Ingredient/admin/`)
            .then(response => {
                setIngredients(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    const postIngredient = () => {
        common_axios.post(`${process.env.REACT_APP_API_URL}/Ingredient/admin/`, {
            name: postName
        })
            .then(() => {
                loadData();
            })
            .catch(error => {
                console.error(error);
            });
    }

    const deleteIngredient = (ingredientId) => {
        common_axios.delete(`${process.env.REACT_APP_API_URL}/Ingredient/admin/` + ingredientId)
            .then(() => {
                loadData();
            })
            .catch(error => {
                console.error(error);
            });
    }

    return (
        <div className='outerBox'>
            <Flex vertical className='flexWrapper'>
                <Divider className='titleReadable' style={{ marginBottom: "20px" }}>Ingredients hinzufügen</Divider>

                <Flex vertical className='form'>
                    <Input className='inputField' placeholder="Name" onChange={(value) => { setName(value.target.value); }} />

                    <Button className='buttonSubmit2' onClick={postIngredient} disabled={postName === ""} style={{ contentFontSize: "10", contentLineHeight: "0.5" }}>Ingredient erstellen</Button>
                </Flex>
                <Divider className='titleReadable' style={{ marginTop: "60px" }}>Ingredients löschen</Divider>
                {ingredients.map(item => (
                    <div className='itemIngredient' key={item.id}>{item.name} <Button onClick={() => deleteIngredient(item.id)}>X</Button></div>
                ))}
            </Flex>
        </div>
    );
};

export default AdminIngredient;